export const groupItemsByProperty = (array: any, propertyName: string) => {
  // Group items by the specified property
  const groupedByProperty: { [key: string]: any } = array.reduce((groups: any, item: any) => {
    const { [propertyName]: propertyValue, ...rest } = item

    // Create a new object that includes both the property and the rest of the item properties
    const newItem = { [propertyName]: propertyValue, ...rest }

    if (!groups[propertyValue]) {
      groups[propertyValue] = { title: propertyValue, items: [] }
    }

    groups[propertyValue].items.push(newItem)
    return groups
  }, {})

  // Convert the grouped object into an array
  return Object.values(groupedByProperty)
}

export const sortArrayByDate = <T>(items: T[], datePropertyName: keyof T) => {
  return items.sort((a: T, b: T) => {
    const dateA = new Date(a[datePropertyName]?.toString() ?? '').getTime()
    const dateB = new Date(b[datePropertyName]?.toString() ?? '').getTime()

    const today = Date.now()
    const timeRemainingA = dateA - today
    const timeRemainingB = dateB - today

    return timeRemainingA - timeRemainingB
  })
}

export const sortArrayAlphabetically = <T>(items: T[], propertyName: keyof T): T[] => {
  return items.sort((a, b) => {
    if (a[propertyName] !== undefined && b[propertyName] !== undefined) {
      return (a[propertyName] as string).localeCompare(b[propertyName] as string)
    } else {
      return 0
    }
  })
}
